module.exports = __webpack_public_path__ + "img/isPr_not1024_lost.c37fe342.png";